(ns quuppa.qsm.projects.subs
  (:require [potpuri.core :as p]
            [quuppa.qsm.events :as e]
            [re-frame.core :as rf]
            [quuppa.peweb.query :as q]
            [quuppa.qsm.projects.events :as pe]))

(rf/reg-sub ::project-id->project
  (fn []
    (q/subscribe pe/projects-query {} [:result]))
  (fn [projects _]
    (p/index-by (comp str :id) projects)))

(rf/reg-sub
  ::project-name->id
  (fn []
    (q/subscribe pe/projects-query {} [:result]))
  (fn [projects _]
    (into {} (map (juxt :name :id) projects))))

(rf/reg-sub
  ::duplicate-project-name
  :<- [::project-name->id]
  (fn [project-name->id [_ project-id project-name]]
    ;; Check if the name is used by a project with different id
    (let [named-project-id (get project-name->id project-name)]
      (and named-project-id
           (not= named-project-id project-id)))))

(rf/reg-sub ::project
  :<- [::project-id->project]
  (fn [projects [_ project-id]]
    (get projects project-id)))

(rf/reg-sub ::loading?
  (q/<-signal-fn pe/projects-query)
  (fn [{:keys [loading]}]
    loading))

;; FIXME this subs were copied from site.subs ns but here cannot be project specific
;; we need to make sure that in this view, we only fetch qpes for projects that user has access to
;; So, perhaps add project-id to the qpe data and query by both project-id and site-id
(rf/reg-sub ::engines
  (q/<-signal-fn e/authorized-qpes {} [:result])
  (fn [qpes [_ site-id]]
    (filter #(= (:site-id %) site-id) (vals qpes))))

;; FIXME: According to 'Project-centric QSM' sc-19504 there can be multiple QPEs in site, but...
(rf/reg-sub ::site-qpe
  (fn [[_ site-id]]
    (rf/subscribe [::engines site-id]))
  (fn [qpes _]
    ;; FIXME: ... for the time-being, only 1:1 relationship between site<->qpe is assumed
    ;; for easier transition from legacy to new UI.
    ;; Supporting N QPEs per site is TODO and unspecified.
    (first qpes)))

;;
;; New and edit project form
;;

(rf/reg-sub ::project-form
  (fn [db]
    (:project-form db)))

(rf/reg-sub ::projects-selected-tab
  (fn [db]
    (-> db :ui-state :projects-selected-tab)))
